import { GET_REASON_CODES_REQUEST, GET_REASON_CODES_SUCCESS, GET_REASON_CODES_ERROR, CLEAR_REASON_CODES_REQUEST } from "redux/actions/action-type";

const initialState = {
    reasonCodesResponse : [],
    isReasonCodesLoading : false,
    isReasonCodesSuccess : false,
    isReasonCodesError : false,
}

const reasonCodesReducer = (state = initialState, {type, payload}) => {
    switch(type) {
        case GET_REASON_CODES_REQUEST:
            return {
                ...state,
                isReasonCodesLoading: true,
                isReasonCodesSuccess: false,
                isReasonCodesError: false,
            };
        case GET_REASON_CODES_SUCCESS: 
        return {
            ...state,
            reasonCodesResponse: payload,
            isReasonCodesLoading: false,
            isReasonCodesSuccess: true,
            isReasonCodesError: false,
        };
        case GET_REASON_CODES_ERROR: 
        return {
            ...state,
            reasonCodesResponse: payload,
            isReasonCodesLoading: false,
            isReasonCodesSuccess: false,
            isReasonCodesError: true,
        };
        case CLEAR_REASON_CODES_REQUEST:
            return initialState;
        default: 
        return state;
    }
}

export default reasonCodesReducer;